/**
 * Microsoft's Office Online viewer. It fetches the document itself, so the
 * url must be public (CFS assets are) and under Office's size limit.
 */
export const OFFICE_ONLINE_EMBED_URL =
  'https://view.officeapps.live.com/op/embed.aspx';

export const buildOfficeOnlineEmbedUrl = (fileUrl: string) =>
  `${OFFICE_ONLINE_EMBED_URL}?src=${encodeURIComponent(fileUrl)}`;
